import { useState } from "react";
import { GridDataStateChangeEvent } from "@progress/kendo-react-grid";
import { DataResult, process } from "@progress/kendo-data-query";

export const useAdoptedRulesTableController = (props: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [rows, setRows] = useState<any>(props.rows ?? []);
  const [columns, setColumns] = useState<any>(props.columns ?? []);
  const [dataState, setDataState] = useState<any>({
    skip: 0,
    take: 20,
    sort: [{ field: "id", dir: "desc" }],
  });
  const [dataResult, setDataResult] = useState<DataResult>(
    process(props.rows, dataState)
  );

  const dataStateChange = (event: GridDataStateChangeEvent) => {
    setDataResult(process(props.rows, event.dataState));
    setDataState(event.dataState);
  };

  return {
    // variable
    loading,
    rows,
    columns,
    dataState,
    dataResult,
    // functions
    dataStateChange,
  };
};
